import gql from 'graphql-tag';
export default gql`
  mutation updateDocusignStatus($applicationId: String!, $docusignStatus: String!) {
    updateDocusignStatus(applicationId: $applicationId, docusignStatus: $docusignStatus) {
      status
      message
    }
  }
`;
